import axiosPost from "./axiosPost";

export const RNPSProgramaGet = async (credentials, data) => {
    const body = {
        service: "RNPSProgramaGet",
        params: {
            rnpsProgramaId: data?.programaId,
        },
    };
    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
